<template>

<div>
    <Suspense>
        <template #fallback>
            <div>loading</div>
        </template>

        <AsyncTest :wordlist="wordlist" :trigger="wordlistTrigger" 
                   :microphoneTrigger="microphoneTrigger"
                  @process-words="processWords"
                  @microphone-status="microphoneStatus" />
    </Suspense>
  </div>

  <TopLine title="Main Menu" :microphoneFlag="isListening"/>
  
  <div v-show="showState == SHOW_EXPLAIN">
    <Explain :title="explainTitle" :message="explainMessage" />
  </div>

  <div v-show="showState == SHOW_MAINMENU">
   
    <div v-show="waitingForMicrophone" class="microphone-text">
    Downloading Language Model<br>Note: could take 30 seconds the first time<br>And connecting to microphone</div>

    <div id="main-selector-container">
      <div @click="onClick('/accountmenu')" class="repselector-left-text">{{ youLoginRegisterText }}</div>
      <div @click="onClick('/lichessmenu')" class="repselector-left-text">Play Lichess</div>
      <div @click="onClick('/enginemenu')" class="repselector-left-text">Play Engines</div>
      <div @click="onClick('/subscribe')" class="repselector-left-text">{{ subscriberText }}</div>
      <div @click="onClick('/supportmenu')" class="repselector-left-text">Support (1.16.1)</div>
      <div style="text-align:right;"><hr><p><em>Say 'Command Explain' for help on any screen</em></p></div>
      <div><br><hr>January 23, 2024 (a) -- I think I've fixed the intermittent "Connect to Lichess" problem. I also made a large number of 'housekeeping' changes. If you have any problems, please report them to me: henry@chessvis.com
      <br><em>Note: speech recognition needs access to the microphone. Nothing is recorded or saved. You can still use the program with the mouse if microphone access is blocked.</em></div>
    </div>

  </div>
  
  <ToolBar :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
  <router-view/>

</template>

<script setup>

import { ref, watch } from 'vue'
import Explain from '@/components/Explain.vue'
import ToolBar from '@/components/ToolBar.vue'
import { useRouter } from 'vue-router';
import { useConnectionStore } from '@/stores/connectionStore';
import AsyncTest from '@/components/AsyncTest.vue'
import { doStartupCheck } from '@/composables/startupCheck.js'
import TopLine from '@/components/TopLine.vue'
import { useVoskStore } from '@/stores/voskStore';
import { getListofVoices } from '@/composables/voicesSupport.js'

const wordlistMainMenu = "command show new scroll up down log in register my account subscribe subscriber support explain play lee chess engine engines ignore mike mute listen set program landing"
const wordlistExplain = "command done"
const wordlistTrigger = ref(0)
const microphoneTrigger = ref(0)
const isListening = ref(true)

const wordlist = ref(wordlistMainMenu)

//console.log("in main menu")

const connectionStore = useConnectionStore()
  
const isDark = ref(connectionStore.getDarkmode != "light")

const urlParams =  new URLSearchParams(window.location.search)

const router = useRouter()

const SHOW_MAINMENU = 0
const SHOW_EXPLAIN = 1
const showState = ref(SHOW_MAINMENU)

const TOOLBAR_SET_HOME = 0
const TOOLBAR_EXPLAIN = 1
const TOOLBAR_MIC = 2
const TOOLBAR_DONE = 0

const toolbarMainMenuElements = [
  { index : TOOLBAR_SET_HOME, label : "Set Program as web home"},
  { index : TOOLBAR_EXPLAIN, label : "Explain" ,disabled : false},
  { index : TOOLBAR_MIC, label : "Mic Mute" ,disabled : false}

]
const toolbarExplainElements = [
  { index : TOOLBAR_DONE, label : "Done" ,disabled : false}
]
const toolbarElements = ref(toolbarMainMenuElements)
const toolbarTrigger = ref(0)

const explainTitle = ref("Main Menu Explanation")
const explainMessage = ref("Say 'Command' and Any Menu item or Toolbar text\n\n'Command Explain' to get screen specific help\n" +
               "'Command Done' to exit the screen (including this one)\n" +
               "'Explain' on the game play screen will describe how to make moves\n" +
               "'Command set program' will bypass the 'app landing page' for www.verbalchess.fun\n\n" +

               "If you have more menu items than can be displayed, say 'command scroll up' or 'command scroll down'")

var isSubscriber = connectionStore.getIsSubscriber

const dummyRef = ref(connectionStore.getDummy)

const youLoginRegisterText = ref((dummyRef.value == 0) ? "My Account" : "Register / Login")
const isSubscriberDisabledFlag = ref(isSubscriber != 1)
const subscriberText = ref((isSubscriberDisabledFlag.value) ? "Subscribe!" : "Subscriber: " +
            connectionStore.getSubscriberExpireDisplayString)

const voskStore = useVoskStore()
const voskFields = voskStore.getVoskFields
const waitingForMicrophone = (voskFields.model == null) ? ref(true) : ref(false)
const welcomeMessageSaid = false

// home page

var verbalHomePage = "app"

// speaking

var voices = []
var engineVoiceNumber = -1
var playerVoiceNumber = -1

doStartupCheck(false,afterStartupCallbackRoutine)

  // https://stackoverflow.com/questions/12489546/getting-a-browsers-name-client-side

  function getBrowserName() {
      const agent = window.navigator.userAgent.toLowerCase();
      const browser =
          agent.indexOf('edge') > -1 ? 'edge'
          : agent.indexOf('edg') > -1 ? 'chromium based edge'
          : agent.indexOf('opr') > -1 && window.opr ? 'opera'
          : agent.indexOf('chrome') > -1 && window.chrome ? 'chrome'
          : agent.indexOf('trident') > -1 ? 'ie'
          : agent.indexOf('firefox') > -1 ? 'firefox'
          : agent.indexOf('safari') > -1 ? 'safari'
          : 'other';

      //console.log(`*********************   ${agent}\n${browser}`);
      return (browser)
  }

function afterStartupCallbackRoutine(stuffChanged) {

  // look at passed URL parameter to see what the default home page is
  if (urlParams.has('app')) {
    verbalHomePage = "app"
    connectionStore.setVerbalHomePage("app")
  }
  else
  if (urlParams.has('program')) {
    verbalHomePage = "program"
    connectionStore.setVerbalHomePage("program")
  }
  else
    verbalHomePage = connectionStore.getVerbalHomePage
  if (verbalHomePage == "program") {
    toolbarMainMenuElements[TOOLBAR_SET_HOME].label = "Set Landing Page as web home"
    toolbarElements.value = toolbarMainMenuElements
    toolbarTrigger.value++
  }
  
  isSubscriber = connectionStore.getIsSubscriber
  dummyRef.value = connectionStore.getDummy
  
  youLoginRegisterText.value = (dummyRef.value == 0) ? "My Account" : "Register / Login"
  isSubscriberDisabledFlag.value = isSubscriber != 1
  subscriberText.value = (isSubscriberDisabledFlag.value) ? "Subscribe!" : "Subscriber: " +
                connectionStore.getSubscriberExpireDisplayString
  getListofVoices(handleVoicesCallback)
}

function handleVoicesCallback(voices1,playerNumber,engineNumber) {
    //console.log("VOICE NUMBERS",playerNumber,engineNumber)
    playerVoiceNumber = playerNumber
    engineVoiceNumber = engineNumber
    voices = voices1
  }

function saySomething(sayAsPlayer,moveString) {
    const voiceNumber = (sayAsPlayer) ? playerVoiceNumber : engineVoiceNumber

    if (window['speechSynthesis'] === undefined) {
      const browserName = getBrowserName()
      //console.log("speech synthesis NOT supported",browserName)
      return
    }

    //console.log("speech synthesis supported",moveString,voiceNumber)
    const rate = 0.9

    var msg = new SpeechSynthesisUtterance()
    msg.rate = rate
    if (voiceNumber >= 0)
      msg.voice = voices[voiceNumber]
    msg.text = moveString
    window.speechSynthesis.speak(msg)
  }

function setToolbarMicrophoneLabel() {
  toolbarMainMenuElements[TOOLBAR_MIC].label = (isListening.value) ? "Mic Mute" : "Mic Listen"
  if (showState.value == SHOW_MAINMENU) {
    toolbarElements.value = toolbarMainMenuElements
    toolbarTrigger.value++
  }
}

function microphoneStatus(isListeningFlag) {
  if (waitingForMicrophone.value == true)
    if (urlParams.has('silent') == false) {
      if(window['speechSynthesis'] === undefined)
        alert("'Text to Speech' is not supported by your browser.\n\nI suggest you try a different browser.")
      else
        saySomething(true,"Welcome to Verbal Chess")
    }

  waitingForMicrophone.value = false
  isListening.value = isListeningFlag
  //console.log("############################## microphone ",isListening.value)
  setToolbarMicrophoneLabel()
}

function onClick(path,puzzleOption) {
  //console.log("################### PATH ",path,puzzleOption)
  if (path == "/puzzles" || path == "/movefollowing") {
    //console.log("path is puzzles or movefollowing")
    connectionStore.setPuzzleType(puzzleOption)
  }
  router.push({ path: path })
}

function toolbarClick(arrayIndex) {
  if (showState.value == SHOW_MAINMENU) {
    switch (arrayIndex) {
      case TOOLBAR_SET_HOME :
        if (verbalHomePage == "program")
          processWords("command set landing")
        else
          processWords("command set program")
        break
      case TOOLBAR_EXPLAIN :
        processWords("command explain")
        break
      case TOOLBAR_MIC :
        microphoneTrigger.value++
        isListening.value = !isListening.value
        setToolbarMicrophoneLabel()
        break
    }
  }
  else
    processWords("command done")
}

function processWords(text) {
  //console.log("text in Main Menu ",text)
  const returnArray = parseWordsSaid(text)
  //console.log("command found",returnArray)

  var url = ""

  switch (returnArray[0]) {
    case "explain" :
      showState.value = SHOW_EXPLAIN
      wordlist.value = wordlistExplain
      wordlistTrigger.value++
      toolbarElements.value = toolbarExplainElements
      toolbarTrigger.value++
      break;
    case "done" :
      showState.value = SHOW_MAINMENU
      wordlist.value = wordlistMainMenu
      wordlistTrigger.value++
      toolbarElements.value = toolbarMainMenuElements
      toolbarTrigger.value++
      break;
    case "engine" :
    case "engines" :
      //console.log("ENGINE MENU")
      router.push("/enginemenu")
      break
    case "lichess" :
      //console.log("LICHESS MENU")
      router.push("/lichessmenu")
      break
    case "support" :
      //console.log("SUPPORT MENU")
      router.push("/supportmenu")
      break
    case "subscribe" :
      //console.log("SUBSCRIBE MENU")
      router.push("/subscribe")
      break
    case "account" :
      //console.log("Account menu")
      router.push("/accountmenu")
      break
    case "set_program" :
      url = "https://www.verbalchess.fun/set_program.html"
      location.href = url
      break
    case "set_app" :
      url = "https://www.verbalchess.fun/set_app.html"
      location.href = url
      break
  }
}

function parseCommands(words,currentWordIndex) {
  
  //console.log("in parse commands",words,currentWordIndex)
  var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
  var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
  var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

  for (var i = 0; i < words.length; i++) {
      if (currentWord == "ignore") {
          return ["ignore",""];
      }
      if (currentWord == "explain") {
          return ["explain",""]
      }
      if (currentWord == "done") {
          return ["done",""]
      }
      if (currentWord == "scroll") {
          if (nextWord == "up") {
              return ["scroll", "up"]
          }
          if (nextWord == "down") {
              return ["scroll", "down"]
          }
      }
      
      if (currentWord == "my" || currentWord == "account" || currentWord == "register" ||
                      (currentWord == "log" && nextWord == "in"))  {
          return ["account", ""]
      }
      if (currentWord == "lee" && nextWord == "chess") {
          return ["lichess",""]
      }
      if (currentWord == "engine" || currentWord == "engines") {
          return ["engines",""]
      }
      if (currentWord == "puzzle" || currentWord == "puzzles") {
          return ["puzzles",""]
      }
      if (currentWord == "support") {
          return ["support",""]
      }
      if (currentWord == "subscribe" || currentWord == "subscriber") {
          return ["subscribe",""]
      }
      if (currentWord == "show" && nextWord == "new") {
          return ["new",""]
      }
      if (currentWord == "set" && nextWord == "landing")
        return ["set_app", ""]
      if (currentWord == "set" && nextWord == "program")
        return ["set_program", ""]

      currentWord = nextWord;
      nextWord = nextNextWord;
      nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
  }
  return ["ignore",""];
}

function parseWordsSaid(str) {
 
  const words = str.split(" ")

  //console.log("string ",str)
  //console.log("words",words,words.length)
  if (words.length == 0) {
      return ["ignore",""];
  }

  var currentWord = (words.length > 0) ? words[0] : "xyz"
  var nextWord = (words.length > 1) ? words[1] : "xyz"
  var nextNextWord = (words.length > 2) ? words[2] : "xyz"
        
  //console.log("current word",currentWord)

  for (var i = 0; i < words.length; i++) {
      if (currentWord == "ignore") {
          return ["ignore",""];
      }

      if (currentWord == "command") {
        let returnArray = parseCommands(words, i+1)
          return returnArray
      }
      currentWord = nextWord;
      nextWord = nextNextWord;
      nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
  }
  return ["ignore",""]
}

</script>

<style scoped>


#main-selector-container {
  position : relative;
  border-style : solid;
  border-width: 2px;
  margin : 30px auto;
  padding : 15px 15px;
  line-height: 1.4em;
  width : 600px;
  height: calc(100vh - 125px);
  overflow-y: auto;
  font-family: "Nunito", sans-serif;   /* rounded */
  cursor: pointer;
}


.repselector-center-text {
  text-align: center;
  margin-bottom : 10px;
  font-style :italic;
}

.repselector-heading-color {
  background: #4c6ca0;
  color : white;
}

.repselector-left-text {
  text-align: left;
  margin-top : -5px;
  margin-bottom : 5px;
}

.microphone-text {
  font-size : 20px;
  font-weight: italic;
  text-align : center;
  color : red;
}

</style>